<template>
  <div>
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">转入状态：</div>
          <Select
            class="bj-select-h45 bj-bg-color-26262A "
            v-model="transferStatus"
            style="width: 180px"
            clearable
          >
            <Option
              v-for="item in transferStatusList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </div>
        <div class="item" style="margin: 0 20px;">
          <Input
            class="bj-input-26262A bj-input-h45"
            v-model="domainName"
            placeholder="请输入搜索的域名名称"
            style="width: 250px"
            clearable
          />
        </div>
        <div class="item">
          <Button
            class="bj-search-btn-F85A36"
            type="primary"
            style="margin-right: 20px"
            @click="onSearch"
            >搜索</Button
          >
          <Button class="bj-border-F85A36" @click="onSearchCancel">重置</Button>
        </div>
      </div>
    </div>
    <div class="bj-table-data">
      <div class="total">搜索结果<span class="count">（{{ total }}）</span></div>
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
        <template slot="transferStatus" slot-scope="{ row }">
          <div>
            {{ row.status | status }}
          </div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <div v-if="row.status === 1" class="table-btn" @click="onCheckStatus(row.id, row.ym)">查询转入状态</div>
          <div v-else-if="row.status === 7" class="bj-rows">
            <div class="table-btn" @click="changeCode(row)">修改转移码</div>
            <div class="table-btn" @click="onDeleteItem(row.id)">取消</div>
          </div>
          <div v-else>--</div>
        </template>
      </Table>
      <div class="page-tool">
        <Page
          class="pages"
          :current="page"
          :total="total"
          :page-size="limit"
          show-total
          show-sizer
          show-elevator
          @on-change="onPageChange"
          @on-page-size-change="onPageSizeChange"
        />
      </div>
    </div>
    <changeTransferCodeModal
      :show.sync="changeTransferCodeModalVisibility"
      :data="changeTransferCodeModalInfo"
      @success="success"
    ></changeTransferCodeModal>
  </div>
</template>

<script>
import {
  transferIntoList,
  transferOutCancel,
  transferIntoDetail,
} from "api/domain.js";
import changeTransferCodeModal from "components/transferin/changeTransferCodeModal.vue";
export default {
  name: "transferinRecord",
  components: {
    changeTransferCodeModal,
  },
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 1:
          title = "待转出";
          break;
        case 2:
          title = "转出中";
          break;
        case 3:
          title = "转出成功";
          break;
        case 4:
          title = "转出失败";
          break;
        case 5:
          title = "用户取消";
          break;
        case 6:
          title = "转移码错误";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      transferStatus: "",
      transferStatusList: [
        {
          value: 1,
          label: "待转出",
        },
        {
          value: 2,
          label: "转出中",
        },
        {
          value: 3,
          label: "转出成功",
        },
        {
          value: 4,
          label: "转出失败",
        },
        {
          value: 5,
          label: "用户取消",
        },
        {
          value: 6,
          label: "转移码错误",
        },
      ],
      domainName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "域名",
          align: "center",
          key: "ym",
        },
        {
          title: "whois邮箱",
          align: "center",
          key: "email",
        },
        {
          title: "创建时间",
          align: "center",
          key: "createdTime",
        },
        {
          title: "转出状态",
          align: "center",
          slot: "transferStatus",
        },
        {
          title: "操作",
          align: "center",
          slot: "action",
        },
      ],
      data: [],
      tableLoading: false,
      changeTransferCodeModalVisibility: false,
      changeTransferCodeModalInfo: {},
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          ym: this.domainName,
          status: this.transferStatus,
          page: this.page,
          limit: this.limit,
        };
        this.tableLoading = true;
        const { code, data } = await transferIntoList(params);
        this.tableLoading = false;
        if (code === 200) {
          this.data = data.list;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 跳页
    onPageChange(val) {
      this.page = val;
      this.req_getList();
    },
    // 页大小
    onPageSizeChange(val){
      this.limit = val;
      this.req_getList();
    },
    // 搜索
    onSearch() {
      this.onPageChange(1);
    },
    // 重置
    onSearchCancel() {
      this.domainName = "";
      this.transferStatus = "";
      this.onPageChange(1);
    },
    // 重新获取转移码
    changeCode(item) {
      this.changeTransferCodeModalVisibility = true;
      this.changeTransferCodeModalInfo = item;
    },
    success() {
      this.req_getList();
    },
    // 取消转出
    onDeleteItem(id) {
      this.$Modal.confirm({
        title: "取消确认",
        content: "<p>确定要取消此转出吗？</p>",
        onOk: async () => {
          const res = await transferOutCancel({
            id,
          });
          const { code, result } = res.data;
          if (code === 200 && result) {
            this.$Message.success("取消成功！");
            this.req_getList();
          }
        },
      });
    },
    // 查询状态
    async onCheckStatus(id, dn) {
      const res = await transferIntoDetail({ id });
      if (res.code === 200) {
        this.$Modal.info({
          title: `${dn}转入状态`,
          content: res.data ? res.data : "-",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.bj-search-section{
    background-color: #28292C;
    padding: 30px 28px;
    border-radius: 6px;
    margin-top: 40px;
    .bj-search-row{
      display: flex;
      .item{
        display: flex;
        align-items: center;
        .name{
          color: #fff;
        }
      }
    }
  }
</style>

